import "./creditSubsequentsTranchesChangeData.css";
import React from 'react';

const ConstProcViewer = (props) => {

    const constProcData = props.constProc.map(constProcX => (
        <>
            <tr key={constProcX.key}>
                    <td>
                        {constProcX.dateFrom}
                    </td>
                    <td>
                        {constProcX.dateTo}
                    </td>
                    <td>
                        {constProcX.value}
                    </td>
                    <td>
                        <button className="actionButtonTable" value={constProcX.key} onClick={props.handleDeleteConstProc}>Usuń</button>
                    </td>
            </tr>
        </>
    ))

    const subsequentsTranchesChangeDataStructure = (
        <table className="subsequentsTranchesChangeTable">
                <tbody>
                    <tr>
                        <th>Data od</th>
                        <th>Data do</th>
                        <th>Wartość</th>
                        <th>Akcja</th>
                    </tr>
                    {constProcData}
                </tbody>
        </table> 
    )

    return ( 
        <>
            <div className="tableRow">
                {props.constProc.length === 0 ? '' : subsequentsTranchesChangeDataStructure}
            </div>  
        </>
    );
}
 
export default ConstProcViewer;
